import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, inject } from 'vue';
import { IProgram } from '@/types/program';
import _ from 'lodash';
import { request } from '@/utils';
import { ColorVariants } from '@/constants';

export interface Expose {
  apply(body?: Record<string, any>): Promise<void>
}

interface IProps {
  program: IProgram;
  applySuccessContent?: string;
  className?: string;
  onSuccess?: Function
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null,
    applySuccessContent: null,
    className: { default: 'dialog-campaign dialog-campaign-apply' },
    onSuccess: null
  },
  setup(__props: any, { expose }) {

const props = __props as { program: IProgram, applySuccessContent?: string, className: string, onSuccess?: Function }

;
const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
const dialog = reactive({
  apply: false,
  applySuccess: false,
  operationSuccess: false,
  requestWaitingLists: false,
  error: false,
});

const requestWaitingListsMessage = ref('');
const errMessage = ref('');

function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}

async function subscribeWaitingList() {
  await request.post('request_waiting_lists', {
    kind: 'collection',
    program_id: props.program.id
  });
  showDialog('operationSuccess');
}

async function apply(body: Record<string, any> = {}) {
  try {
    await request.post('user_requests', {
      target_id: props.program.id,
      target_type: 'Program',
      type: 'CollectionRequest',
      people_collection: props.program.people_collection,
      group_name: props.program.group_name,
      ...body
    }, {
      loading: { silent: true }
    });
    await refreshPageData();
    if (props.onSuccess) {
      await props.onSuccess();
    } else {
      showDialog('applySuccess');
    }
  } catch (e) {
    closeDialog();
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    const status = _.get(e, 'status');
    // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
    if (status !== 401 && String(code) === '40008') {
      requestWaitingListsMessage.value = errorMsg;
      showDialog('requestWaitingLists');
      return;
    }
    // request.ts已经处理过这个code了
    if (String(code) !== '40305') {
      errMessage.value = errorMsg;
      showDialog('error');
    }
    throw e;
  }
}

expose({
  apply
});

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).applySuccess,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).applySuccess) = $event)),
      class: _normalizeClass([__props.className]),
      btns: [
        { text: 'OK', style: _unref(ColorVariants).primary, click: () => closeDialog() }
      ],
      content: __props.applySuccessContent
    }, null, 8, ["visible", "class", "btns", "content"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).operationSuccess,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).operationSuccess) = $event)),
      class: _normalizeClass([__props.className]),
      content: "정보가 성공적으로 입력 되었습니다.",
      btns: [
        { text: 'OK', style: _unref(ColorVariants).primary, click: () => closeDialog() }
      ]
    }, null, 8, ["visible", "class", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).requestWaitingLists,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).requestWaitingLists) = $event)),
      class: _normalizeClass([__props.className]),
      content: requestWaitingListsMessage.value,
      btns: [
        { text: '닫기', style: _unref(ColorVariants).primary, click: () => closeDialog() },
        { text: '신청할게요', style: _unref(ColorVariants).primary, click: () => subscribeWaitingList() }
      ]
    }, null, 8, ["visible", "class", "content", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).error,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).error) = $event)),
      class: _normalizeClass([__props.className]),
      content: errMessage.value,
      btns: [
        { text: 'OK', style: _unref(ColorVariants).primary, click: () => closeDialog() },
      ]
    }, null, 8, ["visible", "class", "content", "btns"])
  ]))
}
}

})